export const locale = {
    'PROPOSALS': {
        'TITLE': 'Заявки',
    },
};
